<template>
    <div id="copilot-drawer"></div>
  </template>
  <script lang="ts">
  import { useEmitter } from '../../composition/useEmitter'
  import { defineComponent } from 'vue'
  import { useAppContext } from '../../composition/useAppContext'
  import { trackPendoEvent } from '../../../util/helper'
  import { useScopedStore } from '@/plugins/setupMicroAppStore'
  import { loadRemote } from '@module-federation/runtime'
  import { CopilotEvents } from '@/events'
  let copilotDrawerComponent: any = {}
  
  export default defineComponent({
    watch: {
      '$route.params.location_id': function (id) {
        // this.handleCopilotDrawer()
        //TODO: Change the Selected Location in the Store
      },
    },
    mounted() {
      const emitter = useEmitter()
      emitter.on(CopilotEvents.LOAD_COPILOT_DRAWER, this.handleCopilotDrawer)
    },
    beforeUnmount() {
      const emitter = useEmitter()
      emitter.off(CopilotEvents.LOAD_COPILOT_DRAWER)
      emitter.off('pendo-track-event-copilot')
      if (copilotDrawerComponent?.unmount) {
        copilotDrawerComponent?.unmount()
        window['copilotApp'] = null
      }
    },
    data() {
      return {
        pendoEventRegistered: false,
      }
    },
    methods: {
      async handleCopilotDrawer(params?: { source?: string; url?: string; payload?: any }) {
        const emitter = useEmitter()
        const eventParams = {
          source: params?.source || 'topbar',
          ...(params?.url && { url: params.url }),
          ...(params?.payload && { payload: params.payload })
        }
        console.log("Event Params from CopilotDrawer.vue", eventParams)
        // track pendo event
        const pendoEventProperties = {
          source: params?.source || 'topbar',
          url: params?.url,
          locationId: params?.payload?.locationId,
          pageUrl: params?.payload?.pageUrl,
          page: params?.payload?.page,
          timestamp: params?.payload?.timestamp
        }
        trackPendoEvent('Copilot Icon Clicked', pendoEventProperties)

        if (copilotDrawerComponent?.unmount) {
          emitter.emit('show-copilot-drawer', eventParams)
          return
        }
        await this.mountCopilotDrawer()
        emitter.emit('show-copilot-drawer', eventParams)
      },
      async mountCopilotDrawer() {
        try {
          if (copilotDrawerComponent?.unmount) return
          const route = this.$route
          const router = this.$router
          const emitter = useEmitter()
          console.log("Emitter from CopilotDrawer.vue", emitter)
          const user = this.$store.getters['user/get']
          const location = await this.$store.getters['locations/getCurrentLocation']
          const store = useScopedStore({
            state: ['locations', 'company', 'user', 'aiCompanyPlan', 'aiLocationPlan'],
            getters: [
              'company/get',
              'user/get',
              'locations/getCurrentLocation',
              'aiCompanyPlan/isSOAEnabled',
              'aiLocationPlan/getSOAOptIn',
              'aiLocationPlan/getProductEnabled',
              'aiLocationPlan/getPlan',
              'aiLocationPlan/getSeasonOfAI',
              'aiLocationPlan/getShowSummerOfAIMenu',
              'aiCompanyPlan/getFeatureFlags',
              'aiCompanyPlan/getAffiliateCode',
              'aiLocationPlan/getShowSummerOfAIMenu',
              'aiLocationPlan/getSeasonOfAI'
            ],
          })
          const userSpecificLanguage = this.$store.state.user?.user?.platformLanguage
          const locationSpecificLanguage = location?.locale_settings?.platform
          const locale = userSpecificLanguage || locationSpecificLanguage || 'en-US'
          const { mountAppContext } = useAppContext()

          const [createApp, page] = await Promise.all([
            loadRemote('copilotApp/vue3').then((m: any) => m.createApp),
            loadRemote('copilotApp/CopilotDrawer').then((m: any) => m.default)
          ])

          copilotDrawerComponent = createApp(page, {
            route,
            router,
            emitter,
            user,
            store,
            locale,
          })
          mountAppContext({ copilotApp: copilotDrawerComponent })
          copilotDrawerComponent.mount(`#copilot-drawer`)
          if (!this.pendoEventRegistered) {
            emitter.on('pendo-track-event-copilot', (pendoData: any) => {
              if (pendoData?.event) trackPendoEvent(pendoData?.event, pendoData?.properties)
            })
            this.pendoEventRegistered = true
          }
        } catch (error) {
          console.error('Error mounting Copilot Drawer:', error)
        }
      },
    },
  })
  </script>
  